export default __webpack_public_path__ + "static/media/icon-edit-gray.05887194.svg";